// Kanban column definitions used in IdeasPage, AllPostsPage, and
// PostsPagePersonalArea. These are NOT pulled from the DB statuses
// collection — they map 1:1 to the worker's queueStatus enum so that
// dragging a card into a column can fire the right outbox event.
//
// Every column's _id === key so KanbanCategory's filter (which checks
// project.status / project.queueStatus against mile._id and mile.key)
// catches cards regardless of which field carries the worker enum.

export const IDEA_KANBAN_STATUSES = [
  { _id: 'pending',  key: 'pending',  name: 'Pending',  statusIndex: 0, value: 1 },
  { _id: 'approved', key: 'approved', name: 'Approved', statusIndex: 1, value: 2 },
  { _id: 'rejected', key: 'rejected', name: 'Rejected', statusIndex: 2, value: 3 },
  { _id: 'posted',   key: 'posted',   name: 'Posted',   statusIndex: 3, value: 4 }
];

export const POST_KANBAN_STATUSES = [
  { _id: 'awaiting-approval', key: 'awaiting-approval', name: 'Awaiting approval', statusIndex: 0, value: 1 },
  { _id: 'approved',          key: 'approved',          name: 'Approved',          statusIndex: 1, value: 2 },
  { _id: 'posting',           key: 'posting',           name: 'Posting',           statusIndex: 2, value: 3 },
  { _id: 'posted',            key: 'posted',            name: 'Posted',            statusIndex: 3, value: 4 },
  { _id: 'posting-failed',    key: 'posting-failed',    name: 'Failed',            statusIndex: 4, value: 5 },
  { _id: 'rejected',          key: 'rejected',          name: 'Rejected',          statusIndex: 5, value: 6 }
];

// The Archived column is a HIDDEN shelf — NOT part of the default board.
// Like the Self-Construction board's archived tab, it only appears once the
// user reveals it ("Show archived"); when revealed it REPLACES the working
// columns so the archived posts get the whole board instead of a thin strip.
// Posts land here via the per-card Archive button (or the 24h auto-archive
// sweep) and leave it — back to 'awaiting-approval' — via the same button.
export const POST_ARCHIVED_STATUS = { _id: 'archived', key: 'archived', name: 'Archived', statusIndex: 6, value: 7 };
